import { useEffect, useRef, useState } from 'react';
import './App.scss';
import { ProductBaseInfo } from '../../model_def';
import api from '../../utils/api';
import httpUtil from '../../utils/httpUtil';
import { toast } from '../../utils/toast';
import CommonList from '../../components/CommonList';
import ScrollView from '../../components/Base/ScrollView';
import Loading from '../../components/Loading';
import Block from '../../components/Base/Block';
import View from '../../components/Base/View';
import MyMallCard from '../../components/MyMallCard';
import CartFloat from '../../components/CartFloat';
import rm from '../../utils/rm';
import HolidayTip, { useHolidayTip } from '../../components/HolidayTip';

enum SortType {
  none = "none",
  price_asc = "price_asc",
  price_desc = "price_desc",
  time_desc = "time_desc",
}

const SortTypes = [
  { key: SortType.none, name: "推荐排序" },
  { key: SortType.price_asc, name: "价格升序" },
  { key: SortType.price_desc, name: "价格降序" },
  { key: SortType.time_desc, name: "最近上架" },
]

function App() {


  const [defaultKeyword, setDefaultKeyword] = useState<string>("");
  const [products, setProducts] = useState<ProductBaseInfo[]>([]);
  const [isLoadongMore, setLoadingMore] = useState<boolean>(true);
  const [isNoMore, setNoMore] = useState<boolean>(false);
  const [isFailed, setFailed] = useState<boolean>(false);
  const [isRefreshing, setRefreshing] = useState<boolean>(false);
  // const [pageIndex, setPageIndex] = useState<number>(1);
  const pageIndexRef = useRef<number>(1);
  const [cartTotalCount, setCardTotalCount] = useState<number>(0);
  const [fitSystemWidnow, setFitSystemWidnow] = useState<boolean>(true);
  const [sortType, setSortType] = useState<SortType>(localStorage.getItem("index_sort_type") as SortType || SortType.none);
  const { isHoloday, tip } = useHolidayTip();

  const loadProductList = (isRefresh: boolean, sortType: SortType) => {
    if (!isRefresh && (isNoMore || isLoadongMore)) {
      return
    }
    if (isRefresh) {
      // wx.showNavigationBarLoading()
      // setPageIndex(1)
      pageIndexRef.current = 1;
      setProducts([])
      setNoMore(false)
      setRefreshing(true);
    } else {
      setLoadingMore(true)
      setNoMore(false)
    }
    var apiUrl = api.get('homepageproducts', {
      Page: pageIndexRef.current,
      PageSize: 15,
      ...(sortType !== SortType.none ? { OrderBy: sortType } : {})
    })
    // var url = app.addCommonParamToUrl(api)
    // console.log('辣店列表：', url)
    httpUtil.request(
      apiUrl,
      function (res: any) {
        console.log("res", res)
        var list = res.data.Content
        if (list && list.length > 0) {
          console.log(list)
          setProducts(isRefresh ? list : products.concat(list));
          // setPageIndex(pageIndex + 1)
          pageIndexRef.current = pageIndexRef.current + 1;
          setLoadingMore(false)
          setRefreshing(false);
        } else {
          setNoMore(true)
          setLoadingMore(false)
          setRefreshing(false)
        }
      },
      function (_res: any) {
        toast.error('加载失败，稍后再试')
        setFailed(true)
        setLoadingMore(false)
        setRefreshing(false);
      },
      'GET',
    )
  }

  useEffect(() => {

    setFitSystemWidnow(rm.isLegalEnv() && rm.getEnv().app === "ithome" && window.location.href.indexOf("fitsystemWindow=1") !== -1);
  }, [])

  useEffect(() => {
    loadProductList(true, sortType);
    localStorage.setItem("index_sort_type", sortType);
  }, [sortType])

  const currentSortName = SortTypes.find(st => st.key === sortType)?.name || "推荐排序";

  return (
    <div className="App">
      <ScrollView
        className="app-list-container"
        scrollY={true}
        enableBackToTop={true}
        scrollWithAnimation={true}
        useWindowScroll={true}
        onReachBottom={() => {
          loadProductList(false, sortType)
        }}
      >
        <div className={`top-header ${fitSystemWidnow ? 'fit-system-window' : ''}`}>
          <div className='msg-box'>
            <img className="icon" src={`/imgs/msg.svg`} />
            <span className={`lines ${isHoloday ? 'flow' : ''}`}>
              <HolidayTip className='line' />
              <span className='line'>商品支持全额或部分金币抵扣，以下单页显示为准。</span>
              <HolidayTip className='line' />
            </span>
          </div>
          {/*  头部我的金币、我的商城、去赚金币 */}
          <MyMallCard />

        </div>

        {/*  编辑精选  */}
        <CommonList
          className='index-list'
          listName="精选好物"
          headerExtra={<div style={{
            fontSize: 12,
            display: "flex",
            alignItems: "center",
            color: "#999"
          }}
            onClick={() => {
              try {
                ((window as any)["rm"] as JSSDKAPI).showActionSheet(
                  {
                    itemList: SortTypes.map(i => i.name),//菜单数组
                    // itemColor: "#000000",//菜单文字颜色
                  },
                  function (res) {

                    if(res.tapIndex !== -1){
                      setSortType(SortTypes[res.tapIndex].key)
                    }
                  }
                );
              } catch (error) {
                toast.error('当前环境不支持')
              }
            }}>
            {currentSortName}
            <img style={{
              width: 12,
              marginLeft: 4
            }} src={require('../../images/dropdown.png')} />
          </div>}
          sources={products}></CommonList>
        {(isLoadongMore || isRefreshing) ? (
          <Loading
            style={{
              width: 25,
              height: 25,
              marginTop: (!products || products.length === 0) ? 200 : 25,
              marginBottom: 25,
              opacity: 0.5
            }}
          ></Loading>
        ) : (
          (isNoMore || isFailed) && (
            <Block>
              <View
                className="loading-tip"
                onClick={() => {
                  if (isFailed) {
                    setNoMore(false);
                    loadProductList(false, sortType);
                  }
                }}
              >
                {isNoMore ? '没有更多了' : '加载失败，点我重试'}
              </View>
            </Block>
          )
        )}
      </ScrollView>
      <CartFloat />
    </div>
  );
}

export default App;
